<div class="space-y-6">
  @for (section of mailSections(); track section.key) {
    <div class="space-y-4" [attr.data-testid]="'section-' + section.key">
      <div class="w-full">
        <app-rich-text-editor
          [key]="section.key"
          [labelPrefix]="('mail.subject' | transloco) + ': '"
          [customTranslationName]="getEmailSubjectForSection()"
          [initialContent]="section.content"
          [saveHandler]="richTextService"
          [disabled]="isButtonDisabled()"
          (statusChange)="onStatusChange()"
          class="w-full"
          [attr.data-testid]="'rich-text-editor-' + section.key"
        >
        </app-rich-text-editor>
      </div>
    </div>
  }
</div>
